import {
    CLEAR_USER_FAVOURITES, FETCH_USER_PROFILE, SUBSCRIBE_USER_FAVOURITES,
    UPDATE_USER_FAVOURITES
} from "../actions/types";

const initialState = {
    uid: "",
    email: "",
    favourites: []
};

export default function(state= initialState, action){
    switch(action.type){
        case FETCH_USER_PROFILE:
            return {
                ...state,
                uid: action.uid,
                email: action.email
            };
        case SUBSCRIBE_USER_FAVOURITES:
            return {
                ...state,
                favourites: action.favourites
            };
        case UPDATE_USER_FAVOURITES:
            return {
                ...state,
                favourites: action.favourites
            };
        case CLEAR_USER_FAVOURITES:
            return {
                ...state,
                favourites: []
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/userProfileReducer.js